import { ContractPackagePriceRequestMessage } from '../../../common/api/clients/packagePrice.api';
import { TranslatedItemsBySupplier } from '../../create-enquiry/hooks/useSupplierSelectionPrices.types';

interface BuildContractSupplierSelectionPriceRequestsProps {
    customerId?: string;
    vesselId?: string;
    portId?: string;
    translatedItemsBySupplier: TranslatedItemsBySupplier[];
    contractIdsBySupplierId: Record<string, string[]>;
}

export const buildContractSupplierSelectionPriceRequests = ({
    customerId,
    vesselId,
    portId,
    translatedItemsBySupplier,
    contractIdsBySupplierId,
}: BuildContractSupplierSelectionPriceRequestsProps) => {
    if (!customerId || !portId) {
        return [];
    }

    const requestEntries = translatedItemsBySupplier.reduce<Map<string, ContractPackagePriceRequestMessage>>(
        (acc, supplierItems) => {
            const contractIds = contractIdsBySupplierId[supplierItems.supplier.id] ?? [];

            contractIds.forEach((contractId) => {
                supplierItems.items.forEach((item) => {
                    if (!item.translatedProduct?.productId) {
                        return;
                    }

                    const request = {
                        portId,
                        customerId,
                        vesselId,
                        contractId,
                        packType: item.packType,
                        productId: item.translatedProduct.productId,
                    };

                    acc.set(`${request.contractId}:${request.productId}:${request.packType}`, request);
                });
            });

            return acc;
        },
        new Map<string, ContractPackagePriceRequestMessage>()
    );

    return [...requestEntries.values()];
};
